import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { FilterTrigger } from "~/components/Filters/SingleFilters/FilterTrigger";
import { SingleTypeFilter } from "~/components/Filters/TypeFilter/SingleTypeFilters";
import { TYPE_FILTERS } from "~/components/Filters/types";
import { baseFiltersOptions } from "~/components/FiltersMenu/types";
import { useFilterParams } from "~/hooks/filters/useFilterParams";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { removeFiltersAction } from "~/store/filters/actions";
export const TypeFilterTrigger = /*#__PURE__*/ memo((param)=>{
    let { availableTypes, onApplyClick, onRemoveClick, onOpenChange } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const dispatch = useDispatch();
    const { typesParam, assetFileKindParam } = useFilterParams();
    const count = useMemo(()=>{
        if (searchImprovements) {
            const typeCount = typesParam.reduce((acc, type)=>{
                if (type === "boards") {
                    acc++;
                } else {
                    var _TYPE_FILTERS_type_subFilters;
                    acc += Object.values((_TYPE_FILTERS_type_subFilters = TYPE_FILTERS[type].subFilters) !== null && _TYPE_FILTERS_type_subFilters !== void 0 ? _TYPE_FILTERS_type_subFilters : {}).length;
                }
                return acc;
            }, 0);
            var _assetFileKindParam_or;
            const assetFileKindCount = [
                assetFileKindParam === null || assetFileKindParam === void 0 ? void 0 : assetFileKindParam.is,
                ...(_assetFileKindParam_or = assetFileKindParam === null || assetFileKindParam === void 0 ? void 0 : assetFileKindParam.or) !== null && _assetFileKindParam_or !== void 0 ? _assetFileKindParam_or : []
            ].filter(Boolean).length;
            return typeCount + assetFileKindCount;
        }
        return typesParam.length;
    }, [
        assetFileKindParam === null || assetFileKindParam === void 0 ? void 0 : assetFileKindParam.is,
        assetFileKindParam === null || assetFileKindParam === void 0 ? void 0 : assetFileKindParam.or,
        searchImprovements,
        typesParam
    ]);
    const content = useMemo(()=>/*#__PURE__*/ _jsx(SingleTypeFilter, {
            availableTypes: availableTypes,
            onApplyClick: onApplyClick
        }), [
        availableTypes,
        onApplyClick
    ]);
    const removeFilter = useCallback(async ()=>{
        const filtersToRemove = [
            {
                type: "type"
            },
            {
                type: "assetFileKind"
            }
        ];
        dispatch(removeFiltersAction({
            filters: filtersToRemove.map((filter)=>filter.type),
            customFields: []
        }));
        onRemoveClick === null || onRemoveClick === void 0 ? void 0 : onRemoveClick(filtersToRemove);
    }, [
        dispatch,
        onRemoveClick
    ]);
    return /*#__PURE__*/ _jsx(FilterTrigger, {
        onRemoveClick: removeFilter,
        count: count,
        filterContent: content,
        title: baseFiltersOptions["type"].label,
        Icon: baseFiltersOptions["type"].icon,
        onOpenChange: onOpenChange
    });
});
TypeFilterTrigger.displayName = "TypeFilterTrigger";
